import { render, staticRenderFns } from "./CartDelivery.vue?vue&type=template&id=8d4828a4&scoped=true"
import script from "./CartDelivery.vue?vue&type=script&lang=js"
export * from "./CartDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4828a4",
  null
  
)

export default component.exports